import 'bootstrap/js/dist/tab';

(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.career_benefits = {
    attach: function attach(context) {

      $('.career-benefits-wide__content .career-benefits-wide__title', context).each(function() {

        this.addEventListener('viewportenter', _ => {
          scrollTrigger(this);
        });

        Promutuel.windowing.enableViewportEvents(this);
      });

      function scrollTrigger(selector) {
        $(selector, context).addClass('active');
      }
    }
  };

})(jQuery, Drupal, drupalSettings);